import React, { FC } from 'react'
import { TextElement } from '../../templateEditor.types'
import { TemplateEditorInlineEditApi } from '../../hooks/document/useTemplateEditorInlineEdit'
import { toDisplaySize } from '../../templateEditor.utils'
import { EditableInlineText } from './EditableInlineText'
import elementStyles from './templateEditorElementViews.jcss'

type Props = {
    element: TextElement
    scale: number
    inlineEdit: TemplateEditorInlineEditApi
}

export const TemplateEditorTextView: FC<Props> = ({ element, scale, inlineEdit }) => {
    const target = { type: 'text' as const, elementId: element.id }
    const editing = inlineEdit.isEditing(target)

    return (
        <div
            className={elementStyles.text}
            style={{
                fontSize: toDisplaySize(element.fontSize, scale),
                color: element.color,
                textAlign: element.align,
            }}
            onDoubleClick={(event) => {
                event.stopPropagation()
                inlineEdit.startInlineEdit(target)
            }}
        >
            <EditableInlineText
                value={element.text}
                editing={editing}
                className={elementStyles.editableText}
                onCommit={inlineEdit.commitInlineEdit}
                onCancel={inlineEdit.cancelInlineEdit}
            />
        </div>
    )
}
